import { useEffect, useState } from "react";
import { toast } from "sonner";
import axios, { API, authed, apiError } from "@/lib/api";

const inputCls = "w-full bg-[#050B14] border border-white/15 px-3 py-2.5 outline-none focus:border-[#D4AF37] transition-colors duration-300";

export default function SettingsPanel({ getToken, onSaved }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    let ignore = false;
    (async () => {
      try { const r = await axios.get(`${API}/admin/settings`, await authed(getToken)); if (!ignore) setS((cur) => cur || r.data); }
      catch (e) { toast.error(apiError(e)); }
    })();
    return () => { ignore = true; };
  }, [getToken]);
  if (!s) return null;
  const save = async (e) => {
    e.preventDefault();
    try {
      const r = await axios.put(`${API}/admin/settings`, { ...s, deposit_pct: Number(s.deposit_pct) }, await authed(getToken));
      setS(r.data); onSaved(r.data); toast.success("Paramètres enregistrés");
    } catch (err) { toast.error(apiError(err)); }
  };
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  return (
    <form onSubmit={save} className="bg-[#0A1325] border border-white/10 p-6 sm:p-8 max-w-xl space-y-5" data-testid="settings-form">
      <p className="text-sm text-slate-400">Ces informations s'affichent au client après votre accord pour qu'il règle l'acompte via MCB Juice.</p>
      <label className="block text-sm"><span className="text-slate-400">Numéro Juice (mobile mauricien)</span>
        <input value={s.juice_number} onChange={set("juice_number")} placeholder="+230 5xxx xxxx" className={inputCls} data-testid="settings-juice-number-input" /></label>
      <label className="block text-sm"><span className="text-slate-400">Nom du bénéficiaire</span>
        <input value={s.juice_name} onChange={set("juice_name")} className={inputCls} data-testid="settings-juice-name-input" /></label>
      <label className="block text-sm"><span className="text-slate-400">Acompte par défaut (%)</span>
        <input type="number" min={1} max={100} value={s.deposit_pct} onChange={set("deposit_pct")} className={inputCls} data-testid="settings-deposit-input" /></label>
      <button type="submit" className="bg-[#D4AF37] text-[#050B14] px-6 py-3 font-medium hover:bg-[#e6c55a] transition-colors duration-300" data-testid="settings-save-btn">Enregistrer</button>
    </form>
  );
}
